if (!customElements.get('variant-charm-collection')) {
  customElements.define('variant-charm-collection', class extends HTMLElement {
    connectedCallback() {
      this.variantModes = JSON.parse(this.dataset.charmVariants);
      this.handleVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('theme:variant:change', this.handleVariantChange);
    }
    disconnectedCallback() {
      document.removeEventListener('theme:variant:change', this.handleVariantChange);
      this.controller?.abort();
    }
    async onVariantChange(event) {
      const variant = event.detail?.variant;
      const mode = this.variantModes[String(variant?.id)];
      if (!mode) return;
      this.controller?.abort();
      if (mode === this.dataset.charmMode) {
        this.hidden = false;
        return;
      }
      this.hidden = true;
      this.controller = new AbortController();
      const controller = this.controller;
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('variant', variant.id);
      try {
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Section request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.querySelector('variant-charm-collection');
        if (!replacement || replacement.dataset.charmMode !== mode) throw new Error('Invalid charm section');
        if (!controller.signal.aborted && this.isConnected) this.replaceWith(replacement);
      } catch (error) {
        if (error.name !== 'AbortError') console.error('Charm collection could not be updated', error);
      }
    }
  });
}
